import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils';
import _ from 'lodash';

const graphInitial = {
    weightChange: [],
    sixMinWalkTest: [],
    sitTostandTest: [],
    wellBeing: [],
    endurance: [],
    liquidNutrition: [],
    sideeffects: [],
    cigarettes: [],
    strength: [],
    alcohol: [],
    breathing: [],
    glasses: [],
    havening: [],
    protein: [],
    mental: [],
    carbohydrates: [],
    vegandfruits: [],
    fat: [],
    sweet: [],
    balance: [],
    cognitive: [],
}
const patientInitial = {
    patDetails: "",
    patDetailsFetchStatus: false,
}
const initialState = {
    ...graphInitial,
    ...patientInitial,
    isPatListFetched: false,
    patientList: [],
    tmDataList: [],
    tmSideEffects: [],
    tasks: [],
    endurance_tasks: [],
    tmLoadingPercentage: 1,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   GET_PATIENT_LIST
    case `${events.GET_PATIENT_LIST}_PENDING`: {
        return {
            ...state,
            isPatListFetched: 'PENDING',
        };
    }
    case `${events.GET_PATIENT_LIST}_FULFILLED`: {
        return {
            ...state,
            patientList: action.payload.data,
            isPatListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_PATIENT_LIST}_REJECTED`: {
        return {
            ...state,
            isPatListFetched: 'REJECTED',
        };
    }

    //ADD_PATIENT_BY_CODE
    case `${events.ADD_PATIENT_BY_CODE}_PENDING`: {
        return {
            ...state,
            isPataddedBycode: 'PENDING',
        };
    }
    case `${events.ADD_PATIENT_BY_CODE}_FULFILLED`: {
        showSuccess('Patient added successfully')
        return {
            ...state,
            patientList: [action.payload.data, ...state.patientList],
            isPataddedBycode: 'FULFILLED',
        };
    }
    case `${events.ADD_PATIENT_BY_CODE}_REJECTED`: {
        if(action.payload.response && action.payload.response.data.error) {
            showError(action.payload.response.data.error)
        }
        return {
            ...state,
            isPataddedBycode: 'REJECTED',
        };
    }


    case `${events.GET_PAT_GRAPH_DATA}_PENDING`: {
        return {
            ...state,
        };
    }
    case `${events.GET_PAT_GRAPH_DATA}_FULFILLED`: {
        var data = action.payload.data;
        if(action.meta.graphType === 'weightChange' || 
            action.meta.graphType === 'sixMinWalkTest' ||
            action.meta.graphType === 'sitTostandTest' ||
            action.meta.graphType === 'wellBeing' ||
            action.meta.graphType === 'cigarettes' ||
            action.meta.graphType === 'sideeffects' ||
            action.meta.graphType === 'endurance' ||
            action.meta.graphType === 'liquidNutrition' ||
            action.meta.graphType === 'strength' ||
            action.meta.graphType === 'alcohol' ||
            action.meta.graphType === 'breathing' ||
            action.meta.graphType === 'glasses' || 
            action.meta.graphType === 'havening' ||
            action.meta.graphType === 'protein' ||
            action.meta.graphType === 'mental' ||
            action.meta.graphType ===  'carbohydrates' ||
            action.meta.graphType === 'vegandfruits' ||
            action.meta.graphType === 'fat' ||
            action.meta.graphType === 'sweet' ||
            action.meta.graphType === 'balance' ||
            action.meta.graphType === 'cognitive'
            ) {
            data = []
            action.payload.data.map((d) => {
                data.push({
                    ...d,
                    ...d.data,
                    day: 'Day ' + d.day,
                    index: d.day,
                })
            })
        }

        state[action.meta.graphType] = data;
        return {
            ...state,
        };
    }
    case `${events.GET_PAT_GRAPH_DATA}_REJECTED`: {
        return {
            ...state,
        };
    }


    case `${events.GET_PAT_DETAILS}_PENDING`: {
        return {
            ...state,
            ...graphInitial,
            patDetailsFetchStatus: 'PENDING',
            patDetails: '',
        };
    }
    case `${events.GET_PAT_DETAILS}_FULFILLED`: {
        return {
            ...state,
            patDetailsFetchStatus: 'FULFILLED',
            patDetails: action.payload.data,
        };
    }
    case `${events.GET_PAT_DETAILS}_REJECTED`: {
        return {
            ...state,
            patDetailsFetchStatus: 'REJECTED',
        };
    }

    //   GET TRIAL MONITOR DATA
    case `${events.GET_TM_LIST}_PENDING`: {
        return {
            ...state,
            isTMFetched: 'PENDING',
        };
    }
    case `${events.GET_TM_LIST}_FULFILLED`: {
        const page  = action.meta.page
        const patCount = action.payload.data.total_patient_count
        var loadingPercentage = Math.round(page * 100 / patCount)
        if(loadingPercentage === 0) {
            loadingPercentage = 1
        }
        if(action.payload.data.data.length === 0) {
            loadingPercentage = 100
        }
        if(page === 0) {
            state.tmSideEffects = action.payload.data.side_effects
            state.tasks = _.orderBy(
                action.payload.data.tasks,
                ['module', 'title'],
                ['asc', 'asc']
              );
            state.endurance_tasks = action.payload.data.endurance_tasks
        }
        return {
            ...state,
            tmDataList: [...state.tmDataList, ... action.payload.data.data],
            tmLoadingPercentage: loadingPercentage,
            isTMFetched: 'FULFILLED',
        };
    }
    case `${events.GET_TM_LIST}_REJECTED`: {
        return {
            ...state,
            isTMFetched: 'REJECTED',
        };
    }
   


    default:
        return state;
    }
}
